<ng-container>
  <div class="company-allow-customs-container">
    <span class="company-allow-customs-container__header" [ngClass]="{ oldStyleTheme: isOldStyleTheme }">
      {{ "MENU.EEZY_CUSTOMS" | translate }}
      <span class="d-lg-none">
        <app-hint-tooltip-icon
          [hint]="
            ('COMPANY.ALLOW_US_CUSTOMS_DESCRIPTION_FIRST' | translate) + ' ' + ('COMPANY.ALLOW_US_CUSTOMS_DESCRIPTION_SECOND' | translate)
          "
        ></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex">
      <div
        class="company-allow-customs-container__checkbox pl-0 pr-0"
        [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }"
      >
        <div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" [formControl]="formGroup.get('isAllowedForCustoms')" class="custom-control-input" id="allowCustoms" />
            <label class="custom-control-label" for="allowCustoms">
              {{ "COMPANY.ALLOW_US_CUSTOMS_LABEL" | translate }}
            </label>
          </div>
        </div>

        <div *ngIf="formGroup.get('isAllowedForCustoms').value" class="company-allow-customs-container__controls">
          <span>
            {{ "COMPANY.ALLOW_US_CUSTOMS_SUBHEADER" | translate }}
          </span>
          <div id="control-ani-cbp">
            <!-- ani cbp-->
            <app-control-wrapper [control]="formGroup.get('identifier')" [helper]="'FORM_HELPER.IDENTIFIER_ANI' | translate">
              <label for="aniCbp" control-label>
                {{ "COMPANY.PLEASE_ENTER_ANI_CBP" | translate }}
              </label>
              <input
                type="text"
                [formControl]="formGroup.get('identifier')"
                class="form-control"
                id="aniCbp"
                name="aniCbp"
                [attr.inputmode]="aniCbpMask.inputmode === 'numeric' ? 'numeric' : 'text'"
                [placeholder]="aniCbpMask.placeholder || ''"
                [mask]="aniCbpMask.mask"
                [appMaskErrorTooltip]="aniCbpMask.maskErrorTooltip"
                [maxMaskLength]="aniCbpMask.maskMaxLength"
                control-wrapper
              />
            </app-control-wrapper>
          </div>
          <div id="control-businessType">
            <!-- business Type-->
            <app-control-wrapper [control]="formGroup.get('businessType')">
              <label for="businessType" control-label>
                {{ "LABELS.BUSINESS_TYPE" | translate }}
              </label>
              <ng-select
                id="businessType"
                class="custom"
                control-wrapper
                bindLabel="description"
                bindValue="value"
                [formControl]="formGroup.get('businessType')"
                [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
                [items]="businessTypes"
              ></ng-select>
            </app-control-wrapper>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
        <div class="company-allow-customs-container-description">
          <span>{{ "COMPANY.ALLOW_US_CUSTOMS_DESCRIPTION_FIRST" | translate }}</span>
        </div>
        <div class="company-allow-customs-container-description" *ngIf="formGroup.get('isAllowedForCustoms').value">
          <span>{{ "COMPANY.ALLOW_US_CUSTOMS_DESCRIPTION_SECOND" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
